import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[hasAnyPermission]',
  standalone: true
})
export class HasAnyPermissionDirective implements OnInit, OnDestroy {
  private permissions: string[] = [];
  private subscription?: Subscription;
  private hasView = false;
  private currentUser: any = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {}

  @Input() set hasAnyPermission(permissions: string[]) {
    this.permissions = permissions || [];
    this.updateView();
  }

  ngOnInit() {
    // Subscribe to user changes to update view when user changes
    this.subscription = this.authService.currentUser$.subscribe((user) => {
      this.currentUser = user;
      this.updateView();
    });
    this.updateView();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateView() {
    const hasPermission = this.checkPermissions();
    
    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private checkPermissions(): boolean {
    if (!this.permissions || this.permissions.length === 0) {
      return false;
    }

    // Check currentUser from AuthService
    if (this.currentUser) {
      // Check permissions array
      if (this.currentUser.permissions && Array.isArray(this.currentUser.permissions)) {
        const hasAny = this.permissions.some(requiredPermission => 
          this.currentUser.permissions.some((permission: any) => {
            if (typeof permission === 'string') {
              return permission === requiredPermission || permission.includes(requiredPermission);
            }
            return permission?.permission === requiredPermission || permission?.permission?.includes(requiredPermission);
          })
        );
        if (hasAny) return true;
      }

      // Check global_permissions array
      if (this.currentUser.global_permissions && Array.isArray(this.currentUser.global_permissions)) {
        const hasAny = this.permissions.some(requiredPermission => 
          this.currentUser.global_permissions.some((permission: any) => {
            if (typeof permission === 'string') {
              return permission === requiredPermission || permission.includes(requiredPermission);
            }
            return permission?.permission === requiredPermission || permission?.permission?.includes(requiredPermission);
          })
        );
        if (hasAny) return true;
      }
    }

    // Check localStorage for permissions (if stored there)
    const permissionStr = localStorage.getItem('permissions');
    if (permissionStr) {
      try {
        const permissions = JSON.parse(permissionStr);
        if (Array.isArray(permissions)) {
          const hasAny = this.permissions.some(requiredPermission => 
            permissions.some((perm: any) => {
              if (typeof perm === 'string') {
                return perm === requiredPermission || perm.includes(requiredPermission);
              }
              return perm?.permission === requiredPermission || perm?.permission?.includes(requiredPermission);
            })
          );
          if (hasAny) return true;
        }
      } catch (e) {
        // Ignore parse errors
      }
    }

    return false;
  }
}

